<template>
    <div>
        <!-- <v-cookie></v-cookie> -->
        <div align="center">
            <br/><br/><br/><br/><br/>
            <div><img src="../../assets/images/logo.gif" /></div>
            <br/>
            <div><strong style="font-size:18px;">新用户  及 已绑定过QQ的老用户</strong></div>
            <br/>
            <div><a href="qqtoken" style="font-size:18px;">点击图片快捷登录<img src="../../assets/images/qqlogin.png" /></a></div>
            <br/>
            <br/>
            <div><strong style="font-size:18px;">未绑定过QQ的老用户</strong></div>
            <br/>
            <div><strong style="font-size:18px;">请返回<a href="http://www.2office.cn" style="font-size:18px;color:blue;">第二办公室主页</a>，用原账号登录，<br/>
                    到账户设置--基本信息中绑定QQ</strong>
            </div>
        </div>
    </div>
</template>
<script>
// import cookie from '@/components/cookie.vue'
export default {
    components : {
        // 'v-cookie' : cookie,
    },
}
</script>



// WEBPACK FOOTER //
// src/components/qq/qqlogin.vue